<h2 mat-dialog-title>{{'GENERAL.CHANGEPASSWORD' | translate}}</h2>

<mat-dialog-content>
    <div *ngIf="errorMessage" class="error-message">
        <mat-icon>error</mat-icon>
        <span>{{ errorMessage }}</span>
    </div>

    <form [formGroup]="changePasswordForm">
        <!-- Old Password Field -->
        <mat-form-field appearance="fill" class="full-width">
            <mat-label>{{'GENERAL.OLDPASSWORD' | translate}}</mat-label>
            <input
                matInput
                formControlName="oldPassword"
                [type]="hideOldPassword ? 'password' : 'text'"
                [disabled]="isLoading"
            />
            <button
                mat-icon-button
                matSuffix
                (click)="togglePasswordVisibility('oldPassword')"
                type="button"
                [disabled]="isLoading"
            >
                <mat-icon>{{ hideOldPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            <mat-error *ngIf="changePasswordForm.get('oldPassword')?.hasError('required')">
                {{'GENERAL.REQUIRED' | translate}}
            </mat-error>
        </mat-form-field>

        <!-- New Password Field -->
        <mat-form-field appearance="fill" class="full-width">
            <mat-label>{{'GENERAL.NEWPASSWORD' | translate}}</mat-label>
            <input
                matInput
                formControlName="newPassword"
                [type]="hideNewPassword ? 'password' : 'text'"
                [disabled]="isLoading"
            />
            <button
                mat-icon-button
                matSuffix
                (click)="togglePasswordVisibility('newPassword')"
                type="button"
                [disabled]="isLoading"
            >
                <mat-icon>{{ hideNewPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            <mat-error *ngIf="getPasswordErrorMessage()">
                {{ getPasswordErrorMessage() }}
            </mat-error>
        </mat-form-field>

        <!-- Confirm Password Field -->
        <mat-form-field appearance="fill" class="full-width">
            <mat-label>{{'GENERAL.CONFIRMPASSWORD' | translate}}</mat-label>
            <input
                matInput
                formControlName="confirmPassword"
                [type]="hideConfirmPassword ? 'password' : 'text'"
                [disabled]="isLoading"
            />
            <button
                mat-icon-button
                matSuffix
                (click)="togglePasswordVisibility('confirmPassword')"
                type="button"
                [disabled]="isLoading"
            >
                <mat-icon>{{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            <mat-error *ngIf="getConfirmPasswordErrorMessage()">
                {{ getConfirmPasswordErrorMessage() }}
            </mat-error>
        </mat-form-field>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" [disabled]="isLoading">
        {{'GENERAL.CANCEL' | translate}}
    </button>
    <button
        mat-raised-button
        color="primary"
        (click)="onSubmit()"
        [disabled]="changePasswordForm.invalid || isLoading"
    >
        <mat-icon *ngIf="isLoading" class="spinner">
            <mat-spinner diameter="20"></mat-spinner>
        </mat-icon>
        <span *ngIf="!isLoading">{{'GENERAL.CHANGEPASSWORD' | translate}}</span>
        <span *ngIf="isLoading">{{'GENERAL.SAVING' | translate}}</span>
    </button>
</mat-dialog-actions>
